export const ADMIN_ROLE_PERMISSIONS = [
	'read_events',
	'read_teams',
	'read_reports',
	'read_projects',
	'add_teams',
	'add_projects',
	'add_reports',
	'delete_teams',
	'delete_projects',
	'delete_reports',
	'delete_organizations',
	'delete_project_token',
	'create_project_badge',
	'add_project_token',
	'update_users',
	'update_organizations',
	'update_teams',
	'update_reports',
	'update_projects',
	'read_project_token',
	'read_organization_users',
	'manage_reports',
	'read_settings',
	'read_team_users',
	'update_team_users',
	'manage_membership_requests',
	'update_project_users',
	'read_organizations',
	'read_organization_contributors',
	'read_projects_contributors',
	'read_public_key',
	'update_public_key',
]

export const EDITOR_ROLE_PERMISSIONS = [
	'read_teams',
	'read_reports',
	'read_projects',
	'read_project_token',
	'read_organization_users',
	'read_team_users',
	'add_project_token',
	'add_projects',
	'add_teams',
	'create_project_badge',
	'read_organizations',
	'read_organization_contributors',
	'read_projects_contributors',
]

export const VIEWER_ROLE_PERMISSIONS = [
	'read_teams',
	'read_reports',
	'read_projects',
	'read_team_users',
	'read_organization_users',
	'create_project_badge',
	'read_organizations',
	'read_organization_contributors',
	'read_projects_contributors',
]
